import styled from 'styled-components';

export const ShowMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
  background: transparent;
  border: none;
  font-size: 13px;
  font-weight: 300;
  color: #1a4d4d;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #0f3333;

    svg {
      transform: translateX(4px);
    }
  }

  svg {
    transition: transform 0.3s ease;
  }
`;
